import { NgModule } from '@angular/core';
import { AvatarComponent } from '@common/shared/components/avatar/avatar.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AvatarComponent],
  exports: [AvatarComponent],
  imports: [CommonModule]
})
export class AvatarModule {}
